import { m } from 'framer-motion'
import { Link as RouterLink } from 'react-router-dom'
// components
import Page from '../../components/Page'
// assets
import PageNotFoundIllustration from '../../assets/illustration_404'
import { useEffect } from 'react'

// ----------------------------------------------------------------------

export default function Page404() {
    const navigateToHome = () => {
        window.location.href = '/'
    }
    useEffect(() => {
        navigateToHome()
    }, [])
    return (
        <Page title='404 Page Not Found'>
            <div className="container mx-auto">
                <div className="max-w-lg mx-auto min-h-screen flex flex-col justify-center items-center py-12 px-4 text-center">
                    <m.div>
                        <h1 className="text-3xl font-bold mb-4">
                            Sorry, page not found!
                        </h1>
                    </m.div>

                    <m.div>
                        <p className="text-gray-600 mb-8">
                            Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL? Be sure to check your
                            spelling.
                        </p>
                    </m.div>

                    <m.div>
                        <PageNotFoundIllustration className="h-64 my-8 md:my-10" />
                    </m.div>

                    <RouterLink to='/'>
                        <button className="px-6 py-2 bg-primary hover:bg-primary-hover text-white font-medium rounded-md transition-colors">
                            Go to Home
                        </button>
                    </RouterLink>
                </div>
            </div>
        </Page>
    )
}
